export const Api = {
  LOGIN: "user/login",
  VERIFY_OTP: "user/verify-otp",
  GET_REGION: "user/get-region",
  GET_MOVIES_BY_ID: "user/get-movies-by-region",
  GET_CINEMA_BY_ID: "user/get-cinema-by-region",
  APPLY_FRANCHISE: "user/apply-franchise",
  CONTACT_US: "user/contact-us",
  GET_USER: "user/user-info",
  UPDATE_USER: "user/profile-update",
  GET_MOVIEDETAILS: "user/movies-details-by-id",
  GET_MOVIE_SHOW_DETAILS: "movie-detils-with-shows",
  SOCIAL_LOGIN: "user/social-login",
  GET_GENERAL_SETTINGS: "user/site-setting",
  GET_GALLERY_IMAGES_LIST: "user/gallery",
  GET_SEAT_LAYOUT: "seat-layout",
  GET_REWARD: "user/get-rewards",
  GET_CMS: "get-cms",
  GET_SHOW_TIMINGS_BY_CINEMA_MOVIE: "show-time-by-cinema-movie",
  GET_PRICE_DETAILS_LIST: "price-details",
  INIT_SEAT_BOOKING: "init-booking",
  ADD_SEATS: "add-seats",
  SET_SEATS: "set-seats",
  CREATE_ORDER: "create-order",
  CANCEL_SEATS: "temp-cancel",
  RAZORPAY_CALLBACK: "redirect-as-per-response",
  BOOKING_DETAILS: "booking-details-by-transid",
  MY_BOOKINGS: "/user/my-booking",
  GET_FOODS_AND_BAVERAGES: "item-details-by-cinema",
  ADD_ITEMS: "add-conssesion",
  GET_SLIDER_IMAGES: "user/sliders",
  GET_BANNER_IMAGES: "user/banners",
  UPDATE_BANNER_CLICK_COUNT: "user/banner-click-count",
  VERIFY_MOBILENUMBER: "user/verify-mobilenumber",
  VERIFY_EMAIL: "user/verify-email",
  RESEND_OTP: "user/resend-otp",
  SUBSCRIBE: "subscribe",
  GET_FAQS: "get-faqs",
  GET_ALL_SEARCH_DATA: "all-search",
  TWENTY_MIN_FRANCHISE_APPLICATION: "user/apply-twenty-min-franchise",
  GET_CALENDER_LIST: "upcoming-movies",
  GET_GEO_LOCATION: "near-by-region",
  GET_MOVIE_SHOW_BY_CINEMA: "user/movie-shows-by-cinema",
  ADD_RATE_REVIEW: "user/write-rate-review",
  LIKE_DISLIKE_MOVIE: "user/like-dis-like-movie",
  SUBMIT_FEEDBACK: "submit-feedback",
  SUBMIT_ADVERTISEMENT: "submit-advertisement",
  SUBMIT_CAREER_APPLICATION: "submit-career",
  INIT_PAYMENT_HDFC: "user/ccavRequestHandler",
  LIST_PARTNER: "admin/list-partner",
  Interested_Uninterested_Movie: "user/interested-uninterested-movie",
  Interested_Uninterested_Movie_List:
    "user/interested-uninterested-movies-by-userId",
  SIMILAR_MOVIES_DETAILS: "user/similar-movies-details",
  PREVIOUS_ORDERS: "user/my-food-bvg-order-list",
  GROUP_BOOKING: "user/add-group-booking",
  REPORT_ISSUE: "user/report-issue",
  BRAND_INFLUENCERS: "user/add-influencer",
  GET_CINEMA: "get-cinema",
  GET_BLOG: "user/blogs",
  GET_RECENT_RELEASES_MOVIE_BY_REGION:
    "user/get-recent-releases-movie-by-region",
  GET_MEMBERSHIP_DETAILS: "/get-loyaity-memberShip",
  GET_ADVERTISE_BANNER: "user/get-advertise-list",
  GET_CAREER_BANNER: "user/get-career-list",
  // GET_COUPON_LIST: "user/coupons",
  GET_COUPON_LIST: "user/get-coupons-by-city-cinema-language",
  APPLY_COUPON: "user/validate-coupon",
  GET_MEMBERSHIP_LIST: "user/get-user-subscription-list",
  BUY_MEMBERSHIP: "user/subscription-ccavRequestHandler",
  GET_MEMBERSHIP_TRANSACTION_LIST: "user/get-membership-by-user",
  GET_MEMBERSHIP_TRANSACTION_LIST_HISTORY:"user/subscription-transaction-list",
  COUPON_CART : "user/coupon-cart",
  REMOVE_CART_COUPON : "user/remove-cart-coupon",
  DOWNLOAD_TICKET: "user/download-ticket-pdf",
  APPLY_COUPON:"user/apply-coupan-new",
  GET_WELCOME_GIFTS:"user/get-user-welcome-gift",
  GET_ALL_CINEMAS:"user/get-all-cinema",
  REDEEM_WELCOME_GIFT:"user/mark-gift-received",
  VERIFY_MEMBERSHIP_COUPON: "user/verify-membership-coupon",
  GET_BOOKING_SESSION: "user/booking-session",
};
